import { IonContent, IonPage } from "@ionic/react";
import { Block } from "baseui/block";
import { HeadingLarge } from "baseui/typography";
import { forwardRef } from "react";
import ReDoAdminPanel from "../../components/ReDoAdminPanel";
import ReDoSpinner from "../../components/ReDoSpinner";
import useWhoAmI from "../../hooks/useWhoAmI";

const Admin = forwardRef((props, ref) => {
  const { isAdmin, loading: authLoading } = useWhoAmI();

  if (authLoading) {
    return (
      <IonPage ref={ref}>
        <IonContent className="ion-padding">
          <ReDoSpinner />
        </IonContent>
      </IonPage>
    );
  }

  if (!isAdmin) {
    return (
      <IonPage ref={ref}>
        <IonContent className="ion-padding">
          <Block padding='4ch'>
            <HeadingLarge>Not authorized</HeadingLarge>
          </Block>
        </IonContent>
      </IonPage>
    );
  }

  return (
    <IonPage ref={ref}>
      <IonContent className="ion-padding">
        <ReDoAdminPanel />
      </IonContent>
    </IonPage>
  );
});

export default Admin;
